/**
 * 추천인 시스템 UI 상수 — 언어팩 키만 관리. 실제 문구는 i18n(ko/en 우선, 나머지는 en 폴백)에서.
 * 다른 기능 수정 시 영향 없도록 이 파일만 참조.
 */
export const REFERRAL_KEYS = {
  MODAL_TITLE: 'referral_modal_title',
  MODAL_CLOSE: 'referral_modal_close',
  LOGIN_TO_USE: 'referral_login_to_use',

  MY_CODE_TITLE: 'referral_my_code_title',
  MY_CODE_LOADING: 'referral_my_code_loading',
  COPY_BTN: 'referral_copy_btn',
  COPY_DONE: 'referral_copy_done',

  INPUT_TITLE: 'referral_input_title',
  INPUT_PLACEHOLDER: 'referral_input_placeholder',
  INPUT_SUBMIT: 'referral_input_submit',
  INPUT_ALREADY_REGISTERED: 'referral_input_already_registered',
  INPUT_SUCCESS: 'referral_input_success',
  SIGNUP_REWARD_HINT: 'referral_signup_reward_hint',
  REGISTERED_SHORT: 'referral_registered_short',
  COUNT_LABEL: 'referral_count_label',
  HELP_LABEL: 'referral_help_label',
  HELP_BODY: 'referral_help_body',

  STATUS_TITLE: 'referral_status_title',
  STATUS_PENDING: 'referral_status_pending',
  STATUS_ACTIVATED: 'referral_status_activated',

  TIER_TITLE: 'referral_tier_title',
  TIER_PROGRESS: 'referral_tier_progress',
  TIER_REWARD_SPOT: 'referral_tier_reward_spot',
  TIER_REWARD_CITY: 'referral_tier_reward_city',
  TIER_CLAIM_BTN: 'referral_tier_claim_btn',
  TIER_CLAIMED: 'referral_tier_claimed',
  TIER_LOCKED: 'referral_tier_locked',

  ERROR_INVALID_CODE: 'referral_error_invalid_code',
  ERROR_SELF_REFERRAL: 'referral_error_self_referral',
  ERROR_ACCOUNT_TOO_OLD: 'referral_error_account_too_old',
  ERROR_MUTUAL: 'referral_error_mutual',
  ERROR_DAILY_LIMIT: 'referral_error_daily_limit',
  ERROR_DAILY_CAP: 'referral_error_daily_cap',
  ERROR_REWARDS_OFF: 'referral_error_rewards_off',
  ERROR_LOAD: 'referral_error_load',
  ERROR_GENERIC: 'referral_error_generic'
};
